import {Inject, Injectable, NgZone} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../config.service';
import {LbHttpService} from '../lb-http.service';
import {LbTranslationService} from '@affluences/lb-utils-front';
import {LocalStorageService} from '../utils/local-storage.service';
import {MatDialog} from '@angular/material/dialog';
import {ErrorService} from '../utils/error.service';
import { EventSourcePolyfill, NativeEventSource } from 'event-source-polyfill'

const EventSource = NativeEventSource || EventSourcePolyfill

@Injectable({
    providedIn: 'root'
})
export class QueueEndpointService {

    queueEndpointSubscription: any
    queueEndpointSseRetry: number = 0

    private queueEndpointLoaded: boolean = false
    private queueEndpointEvent: Subject<any> = new Subject<any>()
    public $queueEndpointEvent: Observable<any> = new Observable<any>()
    public queueEndpoints: any = {}

    constructor (
        @Inject( L10N_LOCALE ) public locale: L10nLocale,
        private zone: NgZone,
        private http: HttpClient,
        public configService: ConfigService,
        public lbHttpService: LbHttpService,
        public lbTranslationService: LbTranslationService,
        public localStorageService: LocalStorageService,
        public dialog: MatDialog,
        private errorService: ErrorService
    ) {
        this.$queueEndpointEvent = this.queueEndpointEvent.asObservable()
    }


    async loadQueueEndpointIfNotLoaded () {
        if ( !this.queueEndpointLoaded ) {
            await this.initSubScribe()
        } else {
            this.sendEndpointStates()
        }
    }

    public sendEndpointStates () {
        if ( Object.keys( this.queueEndpoints ).length > 0 ) {
            this.queueEndpointEvent.next( this.queueEndpoints )
        }
    }

    public unsubscribe () {
        this.queueEndpointLoaded = false
        if ( this.queueEndpointSubscription ) {
            this.queueEndpointSubscription.unsubscribe()
        }
    }

    async initSubScribe () {
        this.unsubscribe()
        this.queueEndpointLoaded = true

        const queueId = this.localStorageService.getSelectedQueue().queueId

        // GET TICKETS WITH SSE
        this.queueEndpointSubscription = (await this.httpGetQueueEndpointSse( queueId )).subscribe( async ( res ) => {
            this.errorService.logDebug( 'Event on endpoint SSE', res )
            this.queueEndpointSseRetry = 0
            if ( res ) {
                await this.updateQueueEndpointsFromEvent( res )
            }
        }, async ( error ) => {
            this.errorService.logError( 'Error while getting selected endpoint by SSE', error )

            if ( error === 'SSE_TEMPORARY_ERROR' || error === 'SSE_CLOSED' ) {
                this.queueEndpointSseRetry++

                if ( this.queueEndpointSseRetry < 5 ) {
                    await this.initSubScribe()
                } else {
                    this.unsubscribe()
                    this.errorService.reloadInterface()
                }
            }
        } )
    }


    async updateQueueEndpointsFromEvent ( event ) {
        this.errorService.logDebug(' updateTicketFromEvent ')
        this.errorService.logDebug(event);

        if ( event.resource === 'ENDPOINT' ) {
            if ( event.actionCategory === 'ALL_DATA' ) {
                const now = Date.now();
                this.queueEndpoints = event.data

            } else if ( event.actionCategory === 'CREATE' || event.actionCategory === 'UPDATE' ) {
                this.queueEndpoints = event.data
            }

            this.queueEndpointEvent.next(this.queueEndpoints)
        }
    }


    async httpGetQueueEndpointSse ( queueId ) {

        let url = this.configService.getQueueEndpointsSSE
        url = url.replace( '{queueId}', queueId )
        const httpOptions = await this.lbHttpService.generateHeaderForLineberty( true, true, 'validation' )

        return Observable.create( ( observer ) => {
            const currentsEndpointSse = new EventSourcePolyfill( this.lbHttpService.applyGetParamsToUrl( url, httpOptions.params ), {
                headers: httpOptions.headers
            } )
            currentsEndpointSse.onopen = () => {
                this.errorService.logDebug( 'Endpoint SSE connected' )
            }
            currentsEndpointSse.onmessage = ( event ) => {
                this.zone.run( () => observer.next( JSON.parse( event.data ) ) )
            }
            currentsEndpointSse.onerror = ( error ) => {
                this.errorService.logError( 'Error on endpoint sse', error )
                this.zone.run( () => observer.error( 'SSE_CLOSED' ) )
            }
        } )
    }


}
